import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles/VisitorLogin.css';
import logo from '../components/images/header/pthinks-logo.webp'; // Import your logo image

const VisitorLogin = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/visitor';

    const handleLogin = (e) => {
        e.preventDefault();
        if (email === 'PTS002' && password === 'bharath@123') {
            localStorage.setItem('isAuthenticated', 'true');
            navigate(from, { replace: true });
        } else {
            alert(t('visitor.invalidCreds'));
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <img src={logo} alt="Logo" className="login-logo" /> {/* Add the logo here */}
                <h2 className="login-title"></h2>
                <form className="login-form" onSubmit={handleLogin}>
                    <div className="form-group">
                        <label>{t('visitor.username')}</label>
                        <input 
                            type="text" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            required 
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('visitor.password')}</label>
                        <input 
                            type="password" 
                            value={password} 
                            onChange={(e) => setPassword(e.target.value)} 
                            required 
                        />
                    </div>
                    <button className="login-button" type="submit">
                        {t('visitor.loginBtn')}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default VisitorLogin;